import { atom } from 'jotai';
import { ToastState } from '../interfaces/Toast';

export const toastAtom = atom<ToastState | null>(null);
